import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeUp } from '../utils/animations';

export function PageCTA({ headline, sub, testId = "page-cta" }) {
    return (
        <section className="bg-navy-900 py-20 md:py-24" data-testid={testId}>
            <div className="max-w-2xl mx-auto px-6 lg:px-12 text-center">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-white mb-4 tracking-tight">
                        {headline}
                    </h2>
                    <p className="text-gray-300 mb-8">{sub}</p>
                    <Link
                        to="/contact"
                        className="inline-block bg-gold-400 text-white px-10 py-4 rounded-sm font-bold text-sm tracking-wide hover:bg-gold-500 transition-colors shadow-sm"
                        data-testid={`${testId}-button`}
                    >
                        Book Your Diagnostic Call with Adam
                    </Link>
                    <p className="text-gray-400 text-sm mt-6">
                        <a href="mailto:adam@whiteglovehiring.com" className="hover:text-gold-400 transition-colors">
                            adam@whiteglovehiring.com
                        </a>
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
